const FATHOM_URL = "https://cdn.usefathom.com/script.js";
const SALESVIEWER_INLINE_SCRIPT = `!(function (s, a, l, e, sv, i, ew, er) {
  try {
    (a =
      s[a] ||
      s[l] ||
      function () {
        throw "no_xhr";
      }),
      (sv = i = "https://salesviewer.org"),
      (ew = function (x) {
        (s = new Image()),
          (s.src =
            "https://salesviewer.org/tle.gif?sva=D4f9z0v2S5A6&u=" +
            encodeURIComponent(window.location) +
            "&e=" +
            encodeURIComponent(x));
      }),
      (l = s.SV_XHR =
        function (d) {
          return (
            (er = new a()),
            (er.onerror = function () {
              if (sv != i) return ew("load_err");
              (sv = "https://www.salesviewer.com/t"), setTimeout(l.bind(null, d), 0);
            }),
            (er.onload = function () {
              (s.execScript || s.eval).call(er, er.responseText);
            }),
            er.open("POST", sv, !0),
            (er.withCredentials = true),
            er.send(d),
            er
          );
        }),
      l(
        "h_json=" +
          1 * ("JSON" in s && void 0 !== JSON.parse) +
          "&h_wc=1&h_event=" +
          1 * ("addEventListener" in s) +
          "&sva=" +
          e
      );
  } catch (x) {
    ew(x);
  }
})(window, "XDomainRequest", "XMLHttpRequest", "D4f9z0v2S5A6");`;
export const SALESVIEWER_GIF_ID = "salesviewer-gif";
export const SALESVIEWER_SCRIPT_ID = "salesviewer-script";

let decided = /dsagree=0|1/.test(document.cookie);
let agreed = /dsagree=1/.test(document.cookie);

export type DsgvoHandler = () => void;

const overlay = document.getElementById("privacyoverlay");
const agree = document.getElementById("agree-ds");
const reject = document.getElementById("reject-ds");

if (!decided) {
  overlay?.classList.add("decide");
}

const setFathomScript = () => {
  const script = document.createElement("script");
  script.src = FATHOM_URL;
  script.setAttribute("data-site", "LAXSUJGE");
  document.head.appendChild(script);
};

const setSalesViewerScript = () => {
  const salesViewerGif = document.createElement("noscript");
  salesViewerGif.innerText = `<img src="https://salesviewer.org/D4f9z0v2S5A6.gif" alt="" style="visibility:hidden;" />;`;
  salesViewerGif.setAttribute("id", SALESVIEWER_GIF_ID);

  const salesViewerScript = document.createElement("script");
  salesViewerScript.innerText = SALESVIEWER_INLINE_SCRIPT;
  salesViewerScript.setAttribute("id", SALESVIEWER_SCRIPT_ID);

  document.body.appendChild(salesViewerScript);
  document.body.appendChild(salesViewerGif);
};

if (agreed) {
  setFathomScript();
  setSalesViewerScript();
} else {
  const fathomScript = Array.from(
    document.head.querySelectorAll("script")
  ).find((value) => value.src && value.src === FATHOM_URL);

  const salesViewerScript = Array.from(
    document.body.querySelectorAll("script")
  ).find((script) => script.getAttribute("id") === SALESVIEWER_SCRIPT_ID);

  const salesViewerGif = Array.from(
    document.body.querySelectorAll("noscript")
  ).find((noscript) => noscript.getAttribute("id") === SALESVIEWER_GIF_ID);

  if (fathomScript) {
    document.head.removeChild(fathomScript);
  }

  if (salesViewerScript) {
    document.body.removeChild(salesViewerScript);
  }

  if (salesViewerGif) {
    document.body.removeChild(salesViewerGif);
  }
}

export const agreeDs = () => {
  agreed = true;
  const expires = new Date().getTime() + 31536000000; /* 1 year */
  document.cookie =
    "dsagree=1; expires=" +
    new Date(expires).toUTCString() +
    "; path=/; domain=cronn.de;";
  setFathomScript();
  setSalesViewerScript();
  overlay?.classList.remove("decide");
};

export const rejectDs = () => {
  agreed = false;
  const expires = new Date().getTime() + 31536000000; /* 1 year */
  document.cookie =
    "dsagree=0; expires=" + new Date(expires).toUTCString() + "; path=/; domain=cronn.de;";
  overlay?.classList.remove("decide");
};

if (agree) {
  agree.onclick = (event) => {
    event.preventDefault();
    agreeDs();
    return false;
  };
}

if (reject) {
  reject.onclick = (event) => {
    event.preventDefault();
    rejectDs();
    return false;
  };
}
